import * as React from 'react'
import { SVGProps } from 'react'

const SvgSidebarPinCrossing = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' width='100%' height='100%' viewBox='3 4 32 32' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter1_d_3272_180)'>
      <path
        d='M18.9598 35.0582L28.0736 25.9443C33.0507 20.9673 33.0507 12.823 28.009 7.78128C22.9673 2.73957 14.823 2.73958 9.78128 7.78128C4.73958 12.823 4.73957 20.9673 9.78128 26.009C9.84591 26.0736 18.9598 35.0582 18.9598 35.0582Z'
        fill='currentColor'
      />
      <path
        d='M18.9598 35.0582L28.0736 25.9443C33.0507 20.9673 33.0507 12.823 28.009 7.78128C22.9673 2.73957 14.823 2.73958 9.78128 7.78128C4.73958 12.823 4.73957 20.9673 9.78128 26.009C9.84591 26.0736 18.9598 35.0582 18.9598 35.0582Z'
        fill='url(#paint0_linear_3272_180)'
        fillOpacity='0.25'
      />
    </g>
    <path
      d='M19.0003 24C18.7589 24 18.5629 23.8042 18.5629 23.5629V22.8053C18.5629 20.5848 17.5517 19.1768 15.3848 18.3876L15.092 19.0922C15.0407 19.2164 14.9562 19.3254 14.8489 19.407C14.7153 19.5084 14.5567 19.5614 14.3905 19.5614C14.3555 19.5614 14.3205 19.5591 14.2855 19.5544C14.0838 19.5264 13.9053 19.4215 13.7823 19.2601L12.1535 17.0991C12.076 16.9971 12.0252 16.8747 12.0072 16.7459C11.95 16.3309 12.241 15.9469 12.6562 15.8892L15.3375 15.5121C15.3725 15.5069 15.4081 15.5045 15.4425 15.5045C15.5422 15.5045 15.6396 15.5238 15.7317 15.5617C15.9195 15.6392 16.0665 15.7849 16.1446 15.9725C16.2228 16.1602 16.2233 16.3665 16.1458 16.5547L15.7195 17.5805C17.0094 18.0566 17.9471 18.7367 18.5623 19.6453V13.9461H17.6305C17.427 13.9461 17.2363 13.8669 17.0928 13.7235C16.9499 13.5796 16.8706 13.389 16.8712 13.1862C16.8712 13.0504 16.908 12.9169 16.9768 12.8009L18.3425 10.3806C18.4492 10.1993 18.6154 10.074 18.8119 10.0239C18.8743 10.0082 18.9385 10 19.002 10C19.1373 10 19.2709 10.0367 19.3881 10.1061C19.4977 10.1708 19.5899 10.2628 19.6552 10.3724L21.0302 12.8079C21.13 12.9769 21.1579 13.1803 21.1072 13.3767C21.0565 13.5737 20.9317 13.7381 20.7567 13.8412C20.6395 13.91 20.5066 13.9461 20.3713 13.9461H19.4377V19.6447C20.0529 18.7367 20.9912 18.056 22.2805 17.5799L21.8548 16.5559C21.695 16.1666 21.8805 15.7213 22.2683 15.5617C22.3604 15.5238 22.4578 15.5045 22.5575 15.5045C22.5925 15.5045 22.6275 15.5069 22.6619 15.5115L25.345 15.8886C25.759 15.9457 26.05 16.3298 25.9928 16.7447C25.9748 16.8735 25.924 16.9959 25.8459 17.0997L24.2183 19.2595C24.0947 19.4221 23.9162 19.527 23.7151 19.555C23.6795 19.5597 23.6445 19.562 23.6095 19.562C23.4427 19.562 23.2847 19.5084 23.1511 19.4075C23.0438 19.326 22.9599 19.2176 22.908 19.0934L22.6158 18.3876C20.4488 19.1768 19.4377 20.5848 19.4377 22.8053V23.5629C19.4377 23.8036 19.2417 24 19.0003 24ZM23.6404 18.5736L25.0318 16.7273L22.7394 16.405L23.6404 18.5736ZM14.3608 18.5736L15.2617 16.405L12.9694 16.7273L14.3608 18.5736ZM20.1742 13.0719L19.0003 10.9925L17.8276 13.0719H20.1742Z'
      fill='white'
    />
    <defs>
      <filter
        id='filter0_f_3272_180'
        x='11'
        y='32'
        width='16'
        height='7'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1.5' result='effect1_foregroundBlur_3272_180' />
      </filter>
      <filter
        id='filter1_d_3272_180'
        x='0.514186'
        y='0.342791'
        width='36.77'
        height='42.0298'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1.8286' />
        <feGaussianBlur stdDeviation='2.74291' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3272_180' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3272_180' result='shape' />
      </filter>
      <linearGradient
        id='paint0_linear_3272_180'
        x1='18.8992'
        y1='4'
        x2='18.8992'
        y2='35.0582'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' />
        <stop offset='1' stop-color='white' stop-opacity='0' />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgSidebarPinCrossing
